import * as actionTypes from '../constants/orderConstants';

export const orderReducer = (state = { loading: false, captcha: null, error: null }, action) => {
  switch (action.type) {
    case actionTypes.CREATE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        captcha: null,
        error: null,
      };
    case actionTypes.CREATE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        captcha: action.payload,
        error: null,
      };
    case actionTypes.CREATE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        captcha: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initState = {
  loading: false,
  orderDetails: null,
  error: null,
};

export const individualOrderReducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.ORDER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        orderDetails: action.payload,
        error: null,
      };
    case actionTypes.ORDER_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


const initial = {
  loading: false,
  orders: [],
  error: null,
};

export const userOrdersReducer = (state = initial, action) => {
  switch (action.type) {
    case actionTypes.USER_ALL_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.USER_ALL_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload,
        error: null,
      };
    case actionTypes.USER_ALL_ORDERS_FAIL:
      return {
        ...state,
        loading: false,
        orders: [],
        error: action.payload,
      };
    default:
      return state;
  }
};





  
  